import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useCart } from '../../context/CartContext';
import { useWishlist } from '../../context/WishlistContext';
import SearchModal from '../../components/feature/SearchModal';

export default function ShopPage() {
  const [filter, setFilter] = useState('all');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('featured');
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [collectionDropdownOpen, setCollectionDropdownOpen] = useState(false);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const { totalItems } = useCart();
  const { addToWishlist, isInWishlist, removeFromWishlist, totalItems: wishlistTotal } = useWishlist();

  const products = [
    { id: 1, name: 'ESSENCE HOODIE', quote: 'Be the change you wish to see', price: 119, category: 'hoodies', image: 'https://public.readdy.ai/ai/img_res/32f8c9b0d56a613201b95eec88090a31.jpg' },
    { id: 2, name: 'CLARITY TEE', quote: 'Same shit Different day', price: 79, category: 'tees', image: 'https://readdy.ai/api/search-image?query=premium%20white%20luxury%20t-shirt%20with%20bold%20black%20text%20Same%20shit%20Different%20day%20printed%20in%20modern%20typography%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=prod2v2&orientation=portrait' },
    { id: 3, name: 'WISDOM HOODIE', quote: 'Know thyself', price: 119, category: 'hoodies', image: 'https://readdy.ai/api/search-image?query=charcoal%20grey%20oversized%20hoodie%20with%20poetic%20verse%20typography%20in%20elegant%20script%20font%20printed%20across%20back%20displayed%20on%20neutral%20background%20luxury%20streetwear%20product%20shot%20emphasizing%20premium%20fabric%20texture%20and%20artistic%20lettering%20detail%20sophisticated%20monochrome%20aesthetic&width=600&height=800&seq=shop3&orientation=portrait' },
    { id: 4, name: 'TRUTH TEE', quote: 'TOMORROW IS ANOTHER DAY', price: 79, category: 'tees', image: 'https://readdy.ai/api/search-image?query=premium%20black%20luxury%20t-shirt%20with%20elegant%20white%20text%20TOMORROW%20IS%20ANOTHER%20DAY%20printed%20in%20bold%20typography%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=prod4v2&orientation=portrait' },
    { id: 5, name: 'SERENITY HOODIE', quote: 'Peace begins within', price: 119, category: 'hoodies', image: 'https://readdy.ai/api/search-image?query=cream%20beige%20oversized%20hoodie%20with%20philosophical%20statement%20in%20refined%20serif%20typography%20on%20front%20neutral%20background%20luxury%20streetwear%20product%20photography%20showcasing%20premium%20fabric%20weight%20and%20elegant%20print%20detail%20sophisticated%20minimalist%20aesthetic%20professional%20lighting&width=600&height=800&seq=shop5&orientation=portrait' },
    { id: 6, name: 'GRACE TEE', quote: 'Elegance is an attitude', price: 79, category: 'tees', image: 'https://readdy.ai/api/search-image?query=white%20premium%20cotton%20t-shirt%20with%20inspirational%20phrase%20in%20clean%20sans-serif%20typography%20simple%20white%20background%20professional%20ecommerce%20product%20photography%20emphasizing%20fabric%20drape%20and%20print%20quality%20luxury%20basics%20minimalist%20composition%20studio%20lighting&width=600&height=800&seq=shop6&orientation=portrait' },
    { id: 7, name: 'MINDFUL HOODIE', quote: 'Present moment, only moment', price: 119, category: 'hoodies', image: 'https://readdy.ai/api/search-image?query=dark%20grey%20premium%20hoodie%20with%20zen%20inspired%20quote%20in%20minimalist%20typography%20on%20chest%20clean%20white%20background%20luxury%20streetwear%20product%20photography%20highlighting%20fabric%20quality%20and%20elegant%20print%20detail%20sophisticated%20aesthetic%20professional%20studio%20lighting&width=600&height=800&seq=shop7&orientation=portrait' },
    { id: 8, name: 'COURAGE TEE', quote: 'Don\'t let idiots ruin your day', price: 79, category: 'tees', image: 'https://readdy.ai/api/search-image?query=premium%20white%20luxury%20t-shirt%20with%20bold%20black%20text%20Don%5Ct%20let%20idiots%20ruin%20your%20day%20printed%20in%20modern%20typography%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=prod6v2&orientation=portrait' },
    { id: 9, name: 'BALANCE HOODIE', quote: 'Harmony in all things', price: 119, category: 'hoodies', image: 'https://readdy.ai/api/search-image?query=light%20grey%20oversized%20hoodie%20with%20philosophical%20phrase%20in%20elegant%20serif%20typography%20displayed%20on%20neutral%20background%20luxury%20streetwear%20product%20shot%20emphasizing%20premium%20fabric%20weight%20and%20refined%20print%20detail%20sophisticated%20monochrome%20aesthetic%20professional%20lighting&width=600&height=800&seq=shop9&orientation=portrait' },
    { id: 10, name: 'VISION TEE', quote: 'See beyond the obvious', price: 79, category: 'tees', image: 'https://readdy.ai/api/search-image?query=white%20premium%20cotton%20t-shirt%20with%20thought%20provoking%20text%20in%20modern%20sans-serif%20typography%20clean%20white%20background%20professional%20ecommerce%20product%20photography%20highlighting%20fabric%20drape%20and%20print%20craftsmanship%20luxury%20basics%20minimalist%20composition%20studio%20lighting&width=600&height=800&seq=shop10&orientation=portrait' },
    { id: 11, name: 'RESILIENCE HOODIE', quote: 'Strength through adversity', price: 119, category: 'hoodies', image: 'https://readdy.ai/api/search-image?query=black%20premium%20hoodie%20with%20powerful%20motivational%20quote%20in%20bold%20typography%20on%20chest%20area%20clean%20white%20background%20luxury%20streetwear%20product%20photography%20emphasizing%20fabric%20quality%20and%20impactful%20print%20detail%20sophisticated%20aesthetic%20professional%20studio%20lighting&width=600&height=800&seq=shop11&orientation=portrait' },
    { id: 12, name: 'FREEDOM TEE', quote: 'Liberation is a state of mind', price: 79, category: 'tees', image: 'https://readdy.ai/api/search-image?query=charcoal%20grey%20premium%20cotton%20t-shirt%20with%20inspirational%20phrase%20in%20elegant%20typography%20centered%20on%20front%20simple%20white%20background%20professional%20product%20photography%20showcasing%20fabric%20texture%20and%20print%20quality%20luxury%20basics%20minimalist%20style%20ecommerce%20presentation&width=600&height=800&seq=shop12&orientation=portrait' },
  ];

  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(p => p.category === selectedCategory);

  const sortedProducts = [...filteredProducts].sort((a, b) => {
    switch (sortBy) {
      case 'price-low':
        return a.price - b.price;
      case 'price-high':
        return b.price - a.price;
      case 'name-az':
        return a.name.localeCompare(b.name);
      case 'name-za':
        return b.name.localeCompare(a.name);
      default:
        return 0;
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <SearchModal isOpen={searchModalOpen} onClose={() => setSearchModalOpen(false)} />
      
      {/* Top Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white z-50 border-b border-black/10">
        <div className="px-6 py-4 flex items-center justify-between">
          {/* Mobile: Hamburger on left */}
          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>

          {/* Desktop: Menu items on left */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/shop" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer">NEW ARRIVALS</Link>
            <div 
              className="relative"
              onMouseEnter={() => setCollectionDropdownOpen(true)}
              onMouseLeave={() => setCollectionDropdownOpen(false)}
            >
              <button className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer flex items-center gap-1">
                COLLECTION
                <i className="ri-arrow-down-s-line text-lg"></i>
              </button>
              {collectionDropdownOpen && (
                <div className="absolute top-full left-0 pt-2">
                  <div className="bg-white border border-black/10 py-2 min-w-[160px] shadow-lg">
                    <Link to="/hoodies" className="block px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer">
                      HOODIES
                    </Link>
                    <Link to="/tees" className="block px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer">
                      T-SHIRTS
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <Link to="/about" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer">ABOUT</Link>
          </div>

          {/* Logo in center */}
          <Link to="/" className="cursor-pointer absolute left-1/2 transform -translate-x-1/2">
            <img 
              src="https://static.readdy.ai/image/6ad45fecb24f9c50dfb1488fc3ba7d2f/1bfa6c5bfe10d7e974b284f405d55895.png" 
              alt="DASHY" 
              className="h-7 md:h-8"
            />
          </Link>
          
          {/* Icons on right */}
          <div className="flex items-center gap-4">
            <button 
              onClick={() => setSearchModalOpen(true)}
              className="w-10 h-10 hidden md:flex items-center justify-center cursor-pointer"
            >
              <i className="ri-search-line text-xl"></i>
            </button>
            <Link to="/wishlist" className="w-10 h-10 flex items-center justify-center cursor-pointer relative">
              <i className="ri-heart-line text-xl"></i>
              {wishlistTotal > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                  {wishlistTotal}
                </span>
              )}
            </Link>
            <Link to="/cart" className="w-10 h-10 flex items-center justify-center cursor-pointer relative">
              <i className="ri-shopping-bag-line text-xl"></i>
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                  {totalItems}
                </span>
              )}
            </Link>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-black/10 bg-white">
            <div className="px-6 py-4 flex flex-col gap-4">
              <Link to="/shop" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>NEW ARRIVALS</Link>
              <div>
                <button 
                  onClick={() => setCollectionDropdownOpen(!collectionDropdownOpen)}
                  className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer flex items-center gap-1 w-full"
                >
                  COLLECTION
                  <i className={`ri-arrow-${collectionDropdownOpen ? 'up' : 'down'}-s-line text-lg`}></i>
                </button>
                {collectionDropdownOpen && (
                  <div className="pl-4 mt-2 space-y-2">
                    <Link to="/hoodies" className="block text-sm tracking-[0.2em] text-neutral-600 hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                      HOODIES
                    </Link>
                    <Link to="/tees" className="block text-sm tracking-[0.2em] text-neutral-600 hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                      T-SHIRTS
                    </Link>
                  </div>
                )}
              </div>
              <Link to="/about" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>ABOUT</Link>
              <div className="flex gap-4 pt-4 border-t border-black/10">
                <button 
                  onClick={() => {
                    setSearchModalOpen(true);
                    setMobileMenuOpen(false);
                  }}
                  className="w-10 h-10 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-search-line text-xl"></i>
                </button>
                <Link to="/wishlist" className="w-10 h-10 flex items-center justify-center cursor-pointer relative" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-heart-line text-xl"></i>
                  {wishlistTotal > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                      {wishlistTotal}
                    </span>
                  )}
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Page Header */}
      <div className="pt-24 md:pt-32 pb-12 md:pb-16 px-6 text-center">
        <h1 className="text-3xl md:text-5xl font-light tracking-[0.2em] md:tracking-[0.3em] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
          NEW ARRIVALS
        </h1>
      </div>

      {/* Filter Bar */}
      <div className="px-6 mb-12">
        <div className="max-w-7xl mx-auto flex items-center justify-between border-y border-black/10 py-4">
          <div className="flex gap-6">
            <button 
              onClick={() => setSelectedCategory('all')}
              className={`text-sm tracking-[0.2em] cursor-pointer whitespace-nowrap ${selectedCategory === 'all' ? 'font-medium' : 'text-neutral-400'}`}
            >
              ALL
            </button>
            <button 
              onClick={() => setSelectedCategory('hoodies')}
              className={`text-sm tracking-[0.2em] cursor-pointer whitespace-nowrap ${selectedCategory === 'hoodies' ? 'font-medium' : 'text-neutral-400'}`}
            >
              HOODIES
            </button>
            <button 
              onClick={() => setSelectedCategory('tees')}
              className={`text-sm tracking-[0.2em] cursor-pointer whitespace-nowrap ${selectedCategory === 'tees' ? 'font-medium' : 'text-neutral-400'}`}
            >
              T-SHIRTS
            </button>
          </div>
          
          <div className="relative">
            <button 
              onClick={() => setSortDropdownOpen(!sortDropdownOpen)}
              className="flex items-center gap-2 text-sm tracking-[0.2em] cursor-pointer whitespace-nowrap"
            >
              SORT
              <i className="ri-arrow-down-s-line text-lg"></i>
            </button>
            {sortDropdownOpen && (
              <div className="absolute top-full right-0 pt-2 z-10">
                <div className="bg-white border border-black/10 py-2 min-w-[200px] shadow-lg">
                  <button 
                    onClick={() => {
                      setSortBy('featured');
                      setSortDropdownOpen(false);
                    }}
                    className="block w-full text-left px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer whitespace-nowrap"
                  >
                    FEATURED
                  </button>
                  <button 
                    onClick={() => {
                      setSortBy('price-low');
                      setSortDropdownOpen(false);
                    }}
                    className="block w-full text-left px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer whitespace-nowrap"
                  >
                    PRICE: LOW TO HIGH
                  </button>
                  <button 
                    onClick={() => {
                      setSortBy('price-high');
                      setSortDropdownOpen(false);
                    }}
                    className="block w-full text-left px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer whitespace-nowrap"
                  >
                    PRICE: HIGH TO LOW
                  </button>
                  <button 
                    onClick={() => {
                      setSortBy('name-az');
                      setSortDropdownOpen(false);
                    }}
                    className="block w-full text-left px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer whitespace-nowrap"
                  >
                    NAME: A-Z
                  </button>
                  <button 
                    onClick={() => {
                      setSortBy('name-za');
                      setSortDropdownOpen(false);
                    }}
                    className="block w-full text-left px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer whitespace-nowrap"
                  >
                    NAME: Z-A
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Products Grid */}
      <section className="px-6 pb-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-product-shop>
            {sortedProducts.map(product => (
              <div key={product.id} className="group">
                <Link to={`/product/${product.id}`} className="block cursor-pointer">
                  <div className="relative aspect-[3/4] bg-neutral-50 mb-4 overflow-hidden">
                    <img 
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        if (isInWishlist(product.id)) {
                          removeFromWishlist(product.id);
                        } else {
                          addToWishlist(product);
                        }
                      }}
                      className="absolute top-4 right-4 w-10 h-10 bg-white/90 backdrop-blur-sm flex items-center justify-center hover:bg-white transition-colors cursor-pointer"
                    >
                      <i className={`${isInWishlist(product.id) ? 'ri-heart-fill text-red-500' : 'ri-heart-line'} text-xl`}></i>
                    </button>
                  </div>
                </Link>
                <h3 className="text-sm tracking-[0.2em] mb-2">{product.name}</h3>
                <p className="text-xs text-neutral-500 mb-2 italic">"{product.quote}"</p>
                <p className="text-sm">${product.price}.00</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <h3 className="text-sm tracking-[0.2em] mb-6">DASHY</h3>
              <p className="text-sm text-neutral-400 leading-relaxed">
                Quiet luxury streetwear with meaningful messages for the modern individual.
              </p>
            </div>
            
            <div>
              <h4 className="text-sm tracking-[0.2em] mb-4">SHOP</h4>
              <ul className="space-y-3 text-sm text-neutral-400">
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">New Arrivals</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">Hoodies</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">T-Shirts</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-sm tracking-[0.2em] mb-4">COMPANY</h4>
              <ul className="space-y-3 text-sm text-neutral-400">
                <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">About Us</Link></li>
                <li><Link to="/contact" className="hover:text-white transition-colors cursor-pointer">Contact Us</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-sm tracking-[0.2em] mb-4">FOLLOW US</h4>
              <div className="flex gap-4">
                <a href="https://instagram.com/Dashyfashionofficial" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 hover:bg-white hover:text-black transition-all cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-neutral-400">
            <div className="flex items-center gap-3">
              <p>© 2024 DASHY FASHION LIMITED. All rights reserved.</p>
            </div>
            <div className="flex gap-6">
              <Link to="/privacy" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white transition-colors cursor-pointer">Terms of Service</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
